import React from 'react';

const stop = (e) => e.preventDefault();

/* One fancy market row. Structure mirrors the reference DOM exactly:
   name column (add-pin + marketevent) · spacer · cs-cls (NO/YES btn-group,
   with a red "ball running" overlay when suspended) · desktop min/max. */
export default function FancyRow({ row, onSelectBet }) {
  /* NO cell = lay (pink), YES cell = back (blue); odd/even rows are both back.
     Ball-running rows are covered by the suspended overlay → not clickable. */
  const pick = (cell) => {
    if (row.ballRunning || !cell.p || !onSelectBet) return;
    const side = /\blay\b/.test(cell.cls) ? 'lay' : 'back';
    onSelectBet({ side, team: (row.name || '').trim(), odds: cell.p, marketName: 'Fancy' });
  };
  return (
    <div className="fancy-detail-list">
      <div>
        <div className="row mx-0 align-items-center tablist-content">
          <div className="col-lg-6 col-md-6 col-7 px-0">
            <div className="d-flex align-items-center">
              <div className="name_of_fancy">
                <a href="javascript:void(0)" className="add-pin" onClick={stop}>
                  <i className="bi bi-bookmark" />
                </a>
                <span className="marketevent"> {row.name} </span>
              </div>
            </div>
            <span className="min-max-mobile"> Min: 100 Max: 25k </span>
          </div>
          <div className="col-lg-2 col-md-2 col-1 px-0" />
          <div className="col-lg-2 col-md-2 col-4 px-0">
            <div className="cs-cls">
              <div className="btn-group">
                {row.cells.map((cell, i) => (
                  <button key={i} className={cell.cls} onClick={row.ballRunning ? undefined : () => pick(cell)}>
                    <span>{cell.p}</span>
                    <small>{cell.v}</small>
                  </button>
                ))}
              </div>
              {row.ballRunning && <div className="suspended">ball running</div>}
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-4 px-0 d-none d-md-block">
            <button className="two-odds-min-max">
              <span className="d-block">Min: 100</span>
              <span className="d-block">Max: 25k</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
